import { render } from "./validation.vue?vue&type=template&id=5564f064"
import script from "./validation.vue?vue&type=script&lang=js"
export * from "./validation.vue?vue&type=script&lang=js"
script.render = render

export default script